import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoutesEnum } from '@unive/core';
import { LayoutModule, PageLayout } from '@unive/layout';

const routes: Routes = [
  {
    path: '',
    component: PageLayout,
    children: [
      { path: '', pathMatch: 'full', loadChildren: () => import('./modules/home').then((m) => m.HomeModule) },
      { path: RoutesEnum.Orv, loadChildren: () => import('./modules/orv').then((m) => m.OrvModule) },
      { path: RoutesEnum.Aov, loadChildren: () => import('./modules/aov').then((m) => m.AovModule) },
      { path: RoutesEnum.Pension, loadChildren: () => import('./modules/pension').then((m) => m.PensionModule) },
      { path: RoutesEnum.Mortgage, loadChildren: () => import('./modules/hypotheek').then((m) => m.HypotheekModule) },
      { path: RoutesEnum.Expenses, loadChildren: () => import('./modules/expenses').then((m) => m.ExpensesModule) },
      { path: '**', redirectTo: '/' },
    ],
  },
];

@NgModule({
  imports: [LayoutModule, RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
